import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Icon from '@material-ui/core/Icon';
import * as apiServices from '../../../../services/apiServices';
import * as Constants from '../../../../core/constants';
import { bindActionCreators } from 'redux';
import { Exercise } from '../../../../core/model';
import { connect } from 'react-redux';
import ModalButton from '../../../../components/atomic/Buttons/ModalButton';
import CreateExerciseModal from '../CreateExerciseModal';
import { getExerciseLibrary, isLibraryLoading, libraryLoaded, exerciseQuery, exerciseBase } from '../../../../modules/Exercise';
import searchController from '../../../../components/hoc/searchController';
import SearchBar from '../../../../components/organism/SearchBar';
import CardGrid from '../../../organism/CardGrid';
import InfoCard from '../../Cards/InfoCard';
import ExerciseViewDetail from '../ExerciseViewDetail';
import Drawer from '@material-ui/core/Drawer';
import { createSelects, createSelect, displayTags } from '../../../../utils';
import { toast } from 'react-toastify';

const CardGridStyled = styled(CardGrid)`

`
const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  width: 700px;
`
const Scrollable = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`

const DrawerStyled = styled(Drawer)`
  
`

const ButtonContainer = styled.div`
  display: flex;
  background-color: black;
`

const ModalButtonStyled = styled(ModalButton)`
  margin: 10px 10px 10px auto;
`

const ExerciseSearch = searchController(SearchBar, 'exercises', { params: { page_size: Constants.PER_PAGE_DEFAULT } });

class ChooseExerciseModal extends React.Component {
  constructor(props){
    super(props);
    this.selects = [];
    this.state = {
      input: '',
      page: Constants.START_PAGE_DEFAULT,
      perPage: Constants.PER_PAGE_DEFAULT,
      gotoNext: false,
      viewModalOpen: false,
      viewExercise: null,
    }
  }

  async componentDidMount() {
    const initialSelect = createSelect('Status', 'Choose a status', 'filter', [
      {
        label: 'Completed',
        value: 'valid'
      },
      {
        label: 'Incomplete',
        value: 'invalid'
      },
    ], false);
    this.selects = [initialSelect];
    this.retrieveExercises();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.open && this.props.open) {
      this.retrieveExercises();
    }
  }

  retrieveExercises = async () => {
    const { getExerciseLibrary, exerciseBase } = this.props;
    const { page, perPage } = this.state;

    try {
      exerciseBase();
      await getExerciseLibrary({ params: { page, page_size: perPage } });
    } catch(e) {
      console.log('component: ',this,e.message);
      toast.error(e.message);
    }
  }

  onSubmit = () => {
    const { input } = this.state;
    const exercise = new Exercise();
    exercise.name = input;

    apiServices.createExercise(exercise)
    .then(response => {
      this.onSelectExercise(response)
    })
    .catch(e => {
      console.log('component: ',this,e);
      toast.error(e.message);
    })
  }

  onChange = event => this.setState({ input: event.target.value });

  onSelectExercise = (exercise, edit) => {
    const { onSubmit, onClose } = this.props;

    onSubmit(exercise,edit);
    onClose();
  }

  openViewModal = (item = null) => this.setState({ viewModalOpen: true, viewExercise: item });

  closeViewModal = () => this.setState({ viewModalOpen: false, viewExercise: null });

  renderCard = (item, index) => {
    return (
      <InfoCard
        key={`${index}-${item.name}`}
        header={item.name}
        subtext1={displayTags(item.tags)}
        subtext2={item.equipment.map(e => e.name).join(', ')}
        chips={item.musclegroup.map(m => m.name)}
        cardButtonIcon={this.props.cardButtonIcon}
        onCardClick={() => this.openViewModal(item)}
        onClick={() => this.onSelectExercise(item)}
      />
    )
  }

  onNext = () => {
    const { exerciseState } = this.props;
    const { totalCount, exercises } = exerciseState;
    if(exercises && totalCount && exercises.length < totalCount && !exerciseState.isLoading) {
      this.setState({gotoNext: true})
    }
  }

  libraryDidLoad = (results, count, query) => {
    this.props.libraryLoaded(results, count, query);
    this.setState({gotoNext: false});
  }

  startQuery = () => {
    const { exerciseQuery, exerciseState } = this.props;
    if(!exerciseState.isLoading) {
      exerciseQuery();
    }
  }

  render() {
    const {
      anchor,
      chooseOnly,
      exerciseState,
      isLibraryLoading,
      onClose,
      open,
      resourceState
    } = this.props;
    const { perPage, gotoNext, viewModalOpen, viewExercise } = this.state;

    // remove?
    let filterExercises = [];

    const includedSelects = {
      cat: true,
      mg: true,
      il: false,
      eq: false,
      fg: false,
      tr: false,
    };

    return (
      <DrawerStyled anchor={anchor} onClose={onClose} open={open}>
        <Container>
          {
            !chooseOnly &&
            <ButtonContainer>
              <ModalButtonStyled variant='contained' color='secondary' modalComponent={(<CreateExerciseModal onSuccess={data => this.onSelectExercise(data, true)}/>)}>
                <Icon>add</Icon> Add
              </ModalButtonStyled>
            </ButtonContainer>
          }
          <ExerciseSearch
            selects={createSelects(resourceState.resourceData, this.selects, includedSelects)}
            getter={isLibraryLoading}
            setter={this.libraryDidLoad}
            base={this.startQuery}
            gotoNext={gotoNext}
            perPage={perPage}
            unique = "unique"
          />
          <Scrollable style={{height: '100vh'}}>
            <CardGridStyled
              data={exerciseState.exercises.filter(item => filterExercises.indexOf(item.id) < 0)}
              renderItem={(item,index) => this.renderCard(item,index)}
              nextPage={this.onNext}
              isLoading={exerciseState.isLoading}
              xs={12}
              sm={12}
              md={12}
              lg={6}
              xl={6}
            />
          </Scrollable>
        </Container>
        {
          viewExercise &&
          <ExerciseViewDetail
            data={viewExercise}
            open={viewModalOpen}
            onBackdropClick={this.closeViewModal}
            onClose={this.closeViewModal}
            allowEdit={false}
          />
        }
      </DrawerStyled>
    );
  }

}

ChooseExerciseModal.propTypes = {
  header: PropTypes.string,
  onSubmit: PropTypes.func,
  onClick: PropTypes.func,
  onClose: PropTypes.func,
  chooseOnly: PropTypes.bool,
  cardButtonIcon: PropTypes.string,
};

ChooseExerciseModal.defaultProps = {
  chooseOnly: false,
}

function mapStateToProps(state) {
  return {
    exerciseState: state.exerciseState,
    resourceState: state.resourceState
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    getExerciseLibrary: getExerciseLibrary,
    isLibraryLoading: isLibraryLoading,
    libraryLoaded: libraryLoaded,
    exerciseQuery: exerciseQuery,
    exerciseBase: exerciseBase
  }, dispatch)
}


export default connect(mapStateToProps, mapDispatchToProps)(ChooseExerciseModal);
